import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function SimpleEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value: string | null = control.value;

        if (!value) {
            return null;
        }

        const emailPattern = /^[^\s@]+(\.[^\s@]+)*@[^\s@]+\.[^\s@]{2,}$/;

        const isValid = emailPattern.test(value);

        return isValid ? null : { email: true };
    };
}
